import { render, staticRenderFns } from "./CompanyNewsItem.vue?vue&type=template&id=0560e2c0&scoped=true"
import script from "./CompanyNewsItem.vue?vue&type=script&lang=js"
export * from "./CompanyNewsItem.vue?vue&type=script&lang=js"
import style0 from "./CompanyNewsItem.vue?vue&type=style&index=0&id=0560e2c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0560e2c0",
  null
  
)

export default component.exports